import { queryClient } from '@frontend/api/src/common/client';

import { GetQuoteHeaderQueryKeyType, LiteQuote } from './types';

const formatQuoteId = (quote?: LiteQuote): string | null => {
  const number = quote?.number;
  const revisionNumber = quote?.revisionNumber;

  return number
    ? revisionNumber
      ? `${number}-${revisionNumber}`
      : String(number)
    : null;
};

export const getQuoteHeaderByNumberQueryKey = (
  numberAndRevisionNumber: string,
): GetQuoteHeaderQueryKeyType => {
  return ['quoteHeader', numberAndRevisionNumber];
};
export const setQueryDataFromQuoteHeader = (quote: LiteQuote) => {
  const numberAndRevision = formatQuoteId(quote);
  if (numberAndRevision) {
    const queryKey = getQuoteHeaderByNumberQueryKey(numberAndRevision);
    // now update the query data from cache
    // NOTE: this will trigger the onSuccess callback for anything subscribed to
    // this query key...meaning it is robust to trigger re-renders
    // https://tanstack.com/query/v3/docs/react/reference/QueryClient#queryclientsetquerydata
    queryClient.setQueryData(queryKey, quote);
  }
};

export const getQueryDataFromQuoteNumber = (
  numberAndRevisionNumber: string | null,
): LiteQuote | undefined => {
  if (!numberAndRevisionNumber) return undefined;
  return queryClient.getQueryData(
    getQuoteHeaderByNumberQueryKey(numberAndRevisionNumber),
  );
};

export const invalidateAllQuoteHeaderQueries = () => {
  queryClient.invalidateQueries(['quoteHeader']);
};

export const invalidateQuoteHeaderQueryKey = (
  numberAndRevisionNumber: string | null,
) => {
  if (numberAndRevisionNumber) {
    queryClient.invalidateQueries(
      getQuoteHeaderByNumberQueryKey(numberAndRevisionNumber),
    );
  }
};
